import { NavigationStates } from "./NavigationStates";

export const Context = () => {
    return {
        navigation_states:NavigationStates()
    }
}